/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd'
import { useRouter } from 'next/router'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import type { TabsPosition } from 'antd/lib/tabs'
import React, { useEffect, useState } from 'react'
import OffsetByExcelSteps from '../OffsetByExcelSteps'
import { CheckOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import FailedPurchasesContent from './FailedPurchasesContent/FailedPurchasesContent'
import SuccessPurchasesContent from './SuccessPurchasesContent/SuccessPurchasesContent'
import {
  recalculateIntegration,
  resetOffsetByExcelState,
  integrationStaticsSelector,
  getIntegrationOptionalFields,
  offsetByExcelMakePurchasesSelector,
} from 'src/features'

const MakePurchaseStep: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { id } = useRouter().query
  const { width } = useWindowSize()
  const [tabPosition, setTabPosition] = useState<TabsPosition>('top')
  const { purchasesResults, failedPurchases } = useAppSelector(offsetByExcelMakePurchasesSelector)
  const { data: { integration_code } } = useAppSelector(integrationStaticsSelector)

  const handleBackClick = () => {
    dispatch(resetOffsetByExcelState())
    dispatch(getIntegrationOptionalFields(Number(id)))
  }

  useEffect(() => {
    if (width <= 800) setTabPosition('left')
    else setTabPosition('top')
  }, [width])

  useEffect(() => { dispatch(recalculateIntegration(integration_code)) }, [])

  return (
    <div className='fade-animation'>
      <Tabs
        size={'middle'}
        tabPosition={tabPosition}
        defaultActiveKey={'SUCCESS'}
        className='col-direction-mobile'
      >
        <Tabs.TabPane
          key='SUCCESS'
          tab={<CustomTitle label={<>{<CheckOutlined />} {t('developers.OffSet.SuccessPurchases')}</>} />}
        >
          <SuccessPurchasesContent purchasesResults={purchasesResults} />
        </Tabs.TabPane>
        <Tabs.TabPane
          key='STOCK'
          tab={<CustomTitle label={<>{<CloseCircleOutlined />} {t('developers.OffSet.FailedPurchases')}</>} />}
        >
          <FailedPurchasesContent
            purchasesResults={purchasesResults}
            failedPurchases={failedPurchases}
          />
        </Tabs.TabPane>
      </Tabs>

      <OffsetByExcelSteps
        nextStepValue={4}
        beforeStepValue={2}
        handleBackClick={handleBackClick}
        isLastStep
      />
    </div>
  )
}

export default MakePurchaseStep
